angular.module('bribac.entities.agentFactory', [])

  .value('agentFactory', function agentFactory(data) {
    return angular.merge({
      // Inherited from Identity.

      id: null,
      firstName: null,
      lastName: null,
      fullName: null,
      address: null,
      postalCode: null,
      city: null,
      phone: null,
      email: null,
      ssn: null,
      locale: 'en',
      roles: ['ROLE_GROUP_ADMIN'],

      // Agent specific.

      subGroups: []
    }, data)
  })
